import { render } from "./loader.vue?vue&type=template&id=ba7f16fe"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=ba7f16fe&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/lego/plugin/loader/loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba7f16fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba7f16fe', __exports__)) {
    api.reload('ba7f16fe', __exports__)
  }
  
  module.hot.accept("./loader.vue?vue&type=template&id=ba7f16fe", () => {
    api.rerender('ba7f16fe', render)
  })

}


export default __exports__